<template>
  <section class="relative">
    <router-link
      v-if="loanOfferRedirect"
      class="text-primary justify-self-end px-5 absolute -top-22 -right-5"
      :to="{name: 'Mandate'}"
    >
      Back
    </router-link>
    <router-link
      v-else-if="myProfileRedirect"
      class="text-primary justify-self-end px-5 absolute -top-22 -right-5"
      :to="{ name: 'Mandate', query: { redirectRouteName: 'My Profile' } }"
    >
      Back
    </router-link>
    <router-link
      v-else-if="applicationDiscrepancyRedirect === 'Application Discrepancy'"
      class="text-primary justify-self-end px-5 absolute -top-22 -right-5"
      :to="{ name: 'Application Discrepancy', query: { redirectRouteName: 'Application Discrepancy' } }"
    >
      Back
    </router-link>
    <router-link
      v-else
      class="text-primary justify-self-end px-5 absolute -top-22 -right-5"
      :to="{ name: 'Post Approval Step 1' }"
    >
      Back
    </router-link>
      <section class="grid grid-cols-1 gap-4 pt-1">
        <div class="grid grid-cols-1 gap-2">
          <!-- Download NACH -->
          <div v-if="currentStep === 1" class="grid gap-1 text-center">
            <p class="font-blogger text-xl font-semibold text-headingColor">Download Your NACH Mandate Form</p>
            <p class="label-text-myriad-primary">Fill and submit the NACH Mandate to move forward.</p>
          </div>
          <!-- Upload NACH -->
           <div v-else class="grid gap-1 text-center">
              <p class="font-blogger text-xl font-semibold text-headingColor">Upload Your Signed NACH Mandate</p>
              <p class="label-text-myriad-primary">Please upload the completed and signed NACH Mandate form to proceed with your application.</p>
           </div>
          <div class="grid justify-center items-center pt-8 relative">
            <img class="w-40 h-40" src="../assets/nach-document.png" alt="Nach document"/>
            <div v-if="currentStep === 1" class="w-20 absolute bottom-0 right-20">
              <Vue3Lottie :animationData="NachDownloadAnimation" :speed="1" :loop="true" />
            </div>
            <div v-else class="w-20 absolute bottom-0 right-20 transform rotate-180">
              <Vue3Lottie :animationData="NachUploadAnimation" :speed="1" :loop="true" />
            </div>
          </div>
          <div class="py-12">
            <div v-if="currentStep === 1" class="grid gap-1 text-left">
              <p class="label-text-myriad-primary font-semibold">How to Complete the NACH Mandate</p>
              <p class="label-text-myriad-primary">
                1. Download the form using the button below. <br/>
                2. Print and fill all required details. <br/>
                3. Sign the form as per your bank’s signature records. <br/>
                4. Keep the filled form ready for upload on the next screen.
              </p>
            </div>
            <div v-else class="grid gap-1 text-left">
              <p class="label-text-myriad-primary font-semibold">Upload Instructions</p>
              <p class="label-text-myriad-primary">
                1. Ensure the form is fully filled. <br/>
                2. Signature should be clear and match bank records. <br/>
                3. Upload a clear scan or high-quality photo. <br/>
                4. Signature or stamp should not cover any terms written on the form. <br/>
                5. Accepted formats: JPG, PNG. <br/>
                6. Maximum file size: 10 MB.
              </p>
            </div>
          </div>
        </div>
      </section>
      <!-- footer -->
      <section>
        <span class="grid pb-10"></span>
        <div class="footer">
          <p v-if="currentStep === 2 && !file" @click="currentStep = 1" class="text-center text-xs font-semibold underline text-hyperLinkColor">
            Download NACH form
          </p>
          <custom-button
            v-if="currentStep === 1"
              variant="primary"
              type="button"
              @click="applicationNachTemplate"
            >
              Download
            </custom-button>
            <template v-if="file && currentStep === 2">
              <div class="flex justify-between items-center w-full">
                <div class="flex">
                  <img
                    src="../assets/image-dummy.svg"
                    alt="Image"
                    class="mr-4"
                    width="46"
                    height="43"
                  />
                  <p class="grid word-wrap">
                    {{ file?.name }}
                    <span class="label">Uploaded</span>
                  </p>
                </div>
                <img
                  src="../assets/radio-check.svg"
                  alt="Green Check"
                  class="w-8"
                  width="18"
                  height="18"
                />
              </div>
            </template>
            <custom-button
              v-if="currentStep === 2"
              variant="primary"
              class="relative self-end md:justify-self-center"
              type="button"
              @click.prevent="requestMedia()"
            >
              Upload
            </custom-button>
        </div>
      </section>
    <router-view v-slot="{ Component }">
      <transition-page>
        <component :is="Component" />
      </transition-page>
    </router-view>
    <!-- Spin Loader -->
    <spin-loader :spinLoading="isSpinLoading"/>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import CustomButton from '../components/CustomButton.vue';
import TransitionPage from '../components/TransitionPage.vue';
import SpinLoader from '../components/spinLoader.vue';
import NachDownloadAnimation from '../assets/animation/Nach-Download-Animation.json';
import NachUploadAnimation from '../assets/animation/Nach-Upload-Animation.json';

export default {
  name: 'PostApprovalStep2',
  components: { CustomButton, TransitionPage, SpinLoader },
  computed: {
    ...mapGetters(['applicationId', 'phone', 'isWalmart', 'latestLoanId']),
  },
  data() {
    return {
      file: undefined,
      isSpinLoading: undefined,
      currentStep: 1,
      NachDownloadAnimation,
      NachUploadAnimation,
      loanOfferRedirect: localStorage.getItem('loanOfferRedirect'),
      myProfileRedirect: localStorage.getItem('myProfileRedirect'),
      applicationDiscrepancyRedirect: localStorage.getItem('routeName'),
      count: 3,
      queryData: this.$route.query,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_NACH_MANDATE, {
        [this.$mixpanelPayload.KEY_MESSAGE]: `Landed on NACH Mandate Page`,
      });
    },
    applicationNachTemplate() {
      if (this.count > 0) {
        this.isSpinLoading = true;
        this.$store
          .dispatch('applicationNachTemplateUrl', {
            applicationId: this.applicationId,
            urlParams: {
              mandateAmount: this.queryData?.mandateAmount || localStorage.getItem('amountOption') || -1,
              mandateUid: localStorage.getItem('mandateUid'),
            },
          })
          .then((result) => {
            this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_NACH_MANDATE, {
              [this.$mixpanelPayload.RESPONSE]: 'success',
              [this.$mixpanelPayload.KEY_MESSAGE]: `API Name:-applicationNachTemplateUrl, mandateAmount: ${this.queryData?.mandateAmount || localStorage.getItem('amountOption')}`,
            });
            this.count = 3;
            window.microapps.openUrl({ url: result.url }); // microapps.openUrl
            this.currentStep = 2;
            this.isSpinLoading = false;
          })
          .catch((err) => {
            this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_NACH_MANDATE, {
              [this.$mixpanelPayload.ERROR_REASON]: err.message,
              [this.$mixpanelPayload.KEY_MESSAGE]: `API Name:-applicationNachTemplateUrl, mandateAmount: ${this.queryData?.mandateAmount || localStorage.getItem('amountOption')}`,
            });
            this.count -= 1;
            this.applicationNachTemplate();
            this.isSpinLoading = false;
          });
      } else {
        this.count = 3;
      }
    },
    requestMedia() {
      const mediaRequest = {
          allowedMimeTypes: ["image/jpeg"],
      };
      window.microapps.requestMedia(mediaRequest).then(response => {
        this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_REQUEST_MEDIA, {
          [this.$mixpanelPayload.RESPONSE]: 'success',
          [this.$mixpanelPayload.KEY_MESSAGE]: `Nach Mandte page upload`,
        });
        const fileByteArray = this.base64ToByteArray(response.bytes);
        const blob = new Blob([fileByteArray], { type: response.mimeType });
        this.openFilePicker(blob);
      })
      .catch((err) => {
        this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_REQUEST_MEDIA, {
          [this.$mixpanelPayload.RESPONSE]: err,
          [this.$mixpanelPayload.KEY_MESSAGE]: `Nach Mandte page upload`,
        });
      });
    },
    base64ToByteArray(base64String) {
      const binaryString = window.atob(base64String);
      const byteArray = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i += 1) {
          byteArray[i] = binaryString.charCodeAt(i);
      }
      return byteArray;
    },
    getFileExtension(blob) {
      const splitName = blob.type.split('/');
      return splitName[splitName.length - 1];
    },
    openFilePicker(blob) {
      const fileExtension = this.getFileExtension(blob);
      const timestamp = new Date().toISOString().replace(/[-:]/g, '').replace(/\..*$/, '');
      const fileName = `${timestamp}.${fileExtension}`;
      // Create a File object
      const file = new File([blob], fileName, {
          lastModified: Date.now(),
          type: blob.type,
      });
      this.uploadFile(file, fileName);
    },
    uploadFile(file, fileName) {
      this.isSpinLoading = true;
      const formData = new FormData();
      formData.append('file', file);
      this.$store
        .dispatch('applicationNachMandate', {
          formData,
          applicationId: this.applicationId,
          loanId: this.queryData?.loanId
        })
        .then(() => {
          this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_NACH_MANDATE, {
            [this.$mixpanelPayload.RESPONSE]: 'success',
            [this.$mixpanelPayload.KEY_MESSAGE]: `API Name:-applicationNachMandate, Loan ID:${this.queryData?.loanId}`,
          });
          this.file = fileName;
          this.isSpinLoading = false;
          this.$router.push({
            name: 'Mandate Success', query: this.$route.query
          });
        })
        .catch((err) => {
          this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_NACH_MANDATE, {
            [this.$mixpanelPayload.ERROR_REASON]: err.message,
            [this.$mixpanelPayload.KEY_MESSAGE]: `API Name:-applicationNachMandate`,
          });
          this.isSpinLoading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.-top-22 {
  top: -5.5rem;
  @media only screen and (max-width: 640px) {
    top: -6rem;
  }
}
</style>
